import { fetchFeedback } from '@/services/api';

export default {
  namespace: 'feedback',
  state: {
    data: [],
    total: 0,
  },

  effects: {
    *getFeedbackData({ payload }, { call, put }) {
      const response = yield call(fetchFeedback, payload);
      yield put({
        type: 'saveFeedbackData',
        payload: response,
      });
    },
  },
  reducers: {
    saveFeedbackData(state, action) {
      const { data, meta } = action.payload;
      return {
        ...state,
        data,
        total: meta.total || 0,
      };
    },
  },
};
